import { useField } from 'formik';
import { MultiSelect } from '../../../common-components/multiselect/CommonMultiselect';
import { Option } from '../../../../models/component-models/ComponentModels';

interface FormikMultiSelectProps {
  name: string;
  options: Option[];
  label?: string;
  placeholder?: string;
}

export const FormikMultiSelect: React.FC<FormikMultiSelectProps> = ({
  name,
  options,
  label,
  placeholder,
}) => {
  const [field, meta, helpers] = useField<string[]>(name);

  return (
    <MultiSelect
      options={options}
      value={field.value}
      onChange={value => helpers.setValue(value)}
      label={label}
      placeholder={placeholder}
      error={meta.touched ? meta.error : undefined}
    />
  );
};
